import React from "react";
import { motion } from "framer-motion";
import FinancialChart from "./charts/FinancialChart";

export const DetailedCharts: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <FinancialChart />
    </motion.div>
  );
};
